var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"person-auth"},[_vm._m(0),_c('div',{staticStyle:{"margin":"10px 0","overflow":"hidden"}},[_c('div',[_c('RealName')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation"},[_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"title",staticStyle:{"color":"#2970FF"}},[_vm._v("实名认证")])])])])
}]

export { render, staticRenderFns }